import React, { Component } from 'react';
import {
  Table,
  Well,
  FormGroup,
  ControlLabel,
  Button,
  Form,
  FormControl,
} from 'react-bootstrap';
import swal from 'sweetalert';
import { invokeApig } from '../libs/awsLib';

import UserPermission from '../components/UserPermissions';

const DriverPermissions = [
  'FridgeTasks',
  'GetAllLocation',
  'GetEmptyChannel',
  'GetFridgeStock',
  'GetInventoryForLocation',
  'GetCheckPointStatus',
  'GetUniqueRoutes',
  'RecordTemperature',
  'UpdateFridgeStock',
  'VanTasks',
].sort();
const ViewFridgePermissions = [
  'GetAllLocation',
  'GetScheduledEvents',
  'GetSpecificLocation',
].sort();
const EditFridgePermissions = [
  'GetUniqueLayoutNames',
  'GetUniquePMTNames',
  'GetUniqueRoutes',
].sort();
const SchedulingFridgeChangesPermissions = [
  'DeleteScheduledEvents',
  'AddScheduledEvent',
].sort();

/* TODO: understand why eslint say that `isLoading` unused */
/* eslint-disable react/no-unused-state */

export default class ViewPermissions extends Component {
  constructor(props) {
    super(props);
    this.file = null;
    this.state = {
      isLoading: true,
      response: {
        permissions: [],
        users: {},
      },
    };
    this.handleClick = this.handleClick.bind(this);
    this.addUserPermission = this.addUserPermission.bind(this);
    this.removePermission = this.removePermission.bind(this);
  }

  async UNSAFE_componentWillMount() {
    this.getUserPermissions();
  }

  async getUserPermissions() {
    try {
      const api_response = await invokeApig({
        path: '/users/permissions',
        method: 'GET',
      });
      this.setState({
        response: api_response.data,
        isLoading: false,
      });
    } catch (e) {
      console.error(e);
      swal('Error!', 'User Action Prohibited!', 'error');
    }
  }

  async removePermission(user, action) {
    try {
      invokeApig({
        path: '/users/permissions/remove',
        method: 'POST',
        body: {
          user,
          action,
        },
      }).then((x) => {
        this.getUserPermissions();
      });
    } catch (e) {
      console.error(e);
      swal('Error!', 'User Action Prohibited!', 'error');
    }
  }

  handleClick(e) {
    e.preventDefault();
    this.addUserPermission(
      e.target.parentElement[0].value,
      e.target.parentElement[1].value,
    );
  }

  async addUserPermission(user, action) {
    try {
      invokeApig({
        path: '/users/permissions',
        method: 'POST',
        body: {
          user,
          action,
        },
      }).then((x) => {
        this.getUserPermissions();
      });
    } catch (e) {
      console.error(e);
      swal('Error!', 'User Action Prohibited!', 'error');
    }
  }

  render() {
    return (
      <div>
        <Well>
          <Form inline>
            <FormGroup controlId="formInlineUser">
              <ControlLabel>User</ControlLabel>{' '}
              <FormControl componentClass="select">
                <option value="do_not_pick">Choose User</option>
                {Object.keys(this.state.response.users)
                  .filter((user) => this.state.response.users[user] !== '')
                  .sort(
                    function (a, b) {
                      const nameA = this.state.response.users[a].toUpperCase(); // ignore upper and lowercase
                      const nameB = this.state.response.users[b].toUpperCase(); // ignore upper and lowercase
                      if (nameA < nameB) {
                        return -1;
                      }
                      if (nameA > nameB) {
                        return 1;
                      }

                      // names must be equal
                      return 0;
                    }.bind(this),
                  )
                  .map((user) => (
                    <option key={user} value={user}>
                      {this.state.response.users[user]}
                    </option>
                  ))}
              </FormControl>
            </FormGroup>{' '}
            <FormGroup controlId="formInlineAction">
              <ControlLabel>Action</ControlLabel>{' '}
              <FormControl componentClass="select">
                <option value="do_not_pick">Choose Permissions</option>
                {this.state.response.permissions
                  .filter((user) => this.state.response.users[user] !== '')
                  .map((user) => user.action)
                  .filter((v, i, a) => a.indexOf(v) === i)
                  .sort()
                  .map((action) => (
                    <option key={action} value={action}>
                      {action}
                    </option>
                  ))}
                {this.state.response.permissions
                  .filter((user) => this.state.response.users[user] !== '')
                  .map((user) => user.action)
                  .filter((v, i, a) => a.indexOf(v) === i)
                  .sort()
                  .map((action) => console.log(action))}
              </FormControl>
            </FormGroup>{' '}
            <Button type="submit" onClick={this.handleClick}>
              Add Permission
            </Button>
          </Form>
        </Well>
        <Table responsive>
          <thead>
            <tr>
              <th>Function</th>
              <th>Permission</th>
            </tr>
          </thead>
          <tbody>
            {DriverPermissions.map((perm, index) => (
              <tr>
                {index === 0 && (
                  <td rowSpan={DriverPermissions.length}>Driver</td>
                )}
                <td>{perm}</td>
              </tr>
            ))}
            {ViewFridgePermissions.map((perm, index) => (
              <tr>
                {index === 0 && (
                  <td rowSpan={ViewFridgePermissions.length}>View Fridges</td>
                )}
                <td>{perm}</td>
              </tr>
            ))}
            {EditFridgePermissions.map((perm, index) => (
              <tr>
                {index === 0 && (
                  <td rowSpan={EditFridgePermissions.length}>Edit Fridges</td>
                )}
                <td>{perm}</td>
              </tr>
            ))}
            {SchedulingFridgeChangesPermissions.map((perm, index) => (
              <tr>
                {index === 0 && (
                  <td rowSpan={SchedulingFridgeChangesPermissions.length}>
                    Scheduling Fridge Changes
                  </td>
                )}
                <td>{perm}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        {Object.keys(this.state.response.users)
          .filter((user) => this.state.response.users[user] !== '')
          .sort(
            function (a, b) {
              const nameA = this.state.response.users[a].toUpperCase(); // ignore upper and lowercase
              const nameB = this.state.response.users[b].toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }

              // names must be equal
              return 0;
            }.bind(this),
          )
          .map((user) => (
            <UserPermission
              key={this.state.response.users[user]}
              permissions={{
                delete_action: this.removePermission,
                email: this.state.response.users[user],
                actions: this.state.response.permissions.filter(
                  (user_per) => user === user_per.uuid,
                ),
              }}
            />
          ))}
      </div>
    );
  }
}
